import { Row } from 'react-grid-system'
import styled from 'styled-components'

export const MyFacilityContainer = styled.div`
  width: 100%;
  padding: 0px 325px;
`
export const MyFacilityRow = styled(Row)`
  width: 100%;
  margin: 15px 0;
`
